import React from 'react'

import classNames from 'classnames'

import Logo from 'Root/Component/Header/Logo'
import Link from 'Root/Component/Link'
import ShadowedHeader from 'Root/Component/ShadowedHeader'
import { useCurrentUserId } from 'lib/use-current-user-id'
import { useIsClient } from 'lib/use-is-client'
import Image from 'next/image'
import { useRouter } from 'next/router'

import Back from '../Buttons/Back'
import HomeButton from '../Buttons/Home'
import RootLink from './Link'
import styles from './index.module.css'

export interface Props {
  children: React.ReactNode | React.ReactNode[]
  creator?: ElementCreator
  className?: string
}

interface ElementCreator {
  profileName: string
  logoURL: string
}

const SideNavigationBack = ({
  creator = null,
}: {
  creator: ElementCreator
}) => {
  const userId = useCurrentUserId()
  const { pathname } = useRouter()
  const isClient = useIsClient()

  if (pathname === '/') {
    return (
      <RootLink>
        <Logo />
      </RootLink>
    )
  }

  if (pathname.includes('/workspace/')) {
    return (
      creator?.logoURL && (
        <Link
          className="relative w-10 h-10 "
          to={`/profile/${creator.profileName}`}
        >
          <Image
            alt="brand-logo"
            src={creator.logoURL || ''}
            fill
            className="object-cover rounded-full"
          />
        </Link>
      )
    )
  }

  if (!isClient) return null

  return (
    <>
      {creator?.logoURL && (
        <Link
          className="relative w-10 h-10 "
          to={`/profile/${creator.profileName}`}
        >
          <Image
            alt="brand-logo"
            src={creator.logoURL || ''}
            fill
            className="object-cover rounded-full"
          />
        </Link>
      )}
      {userId && <HomeButton />}
      <Back />
    </>
  )
}

const Wrapper = ({ children, creator, className }: Props) => {
  return (
    <ShadowedHeader
      className={classNames(styles.headerWrapper, className ? className : '')}
      id="top-header"
    >
      <div className={styles.container}>
        <SideNavigationBack creator={creator} />
        <div className="flex-grow"> </div>
        {children}
      </div>
    </ShadowedHeader>
  )
}

export default Wrapper
